export const timeAgoModern = (date) => {
  if (!date) return '';
  
  const inputDate = new Date(date);
  if (isNaN(inputDate.getTime())) return '';
  
  const now = new Date();
  const diffInSeconds = Math.floor((now - inputDate) / 1000);
  
  if (diffInSeconds < 0) return 'Дата из будущего';
  
  const rtf = new Intl.RelativeTimeFormat('ru', { numeric: 'auto' });
  
  if (diffInSeconds < 60) return rtf.format(0, 'second');
  if (diffInSeconds < 3600) return rtf.format(-Math.floor(diffInSeconds / 60), 'minute');
  if (diffInSeconds < 86400) return rtf.format(-Math.floor(diffInSeconds / 3600), 'hour');
  if (diffInSeconds < 2592000) return rtf.format(-Math.floor(diffInSeconds / 86400), 'day');
  if (diffInSeconds < 31536000) return rtf.format(-Math.floor(diffInSeconds / 2592000), 'month');
  return rtf.format(-Math.floor(diffInSeconds / 31536000), 'year');
}